import { useRef } from "react";
import { useWatch } from "react-hook-form";
function isFormValueEqual(a, b) {
    if (Object.is(a, b)) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if ('object' != typeof a || 'object' != typeof b || null === a || null === b) return false;
    if (Array.isArray(a) !== Array.isArray(b)) return false;
    const aRecord = a;
    const bRecord = b;
    const keys = new Set([
        ...Object.keys(aRecord),
        ...Object.keys(bRecord)
    ]);
    for (const key of keys)if (!isFormValueEqual(aRecord[key], bRecord[key])) return false;
    return true;
}
function useFormChangedFromInitial(control) {
    const values = useWatch({
        control
    });
    const initialRef = useRef(null);
    initialRef.current ??= structuredClone(values);
    return !isFormValueEqual(initialRef.current, values);
}
export { isFormValueEqual, useFormChangedFromInitial };
